import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=2b16c810&"
import script from "./ListPage.vue?vue&type=script&lang=js&"
export * from "./ListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports